import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tour";

moduleApi.create = (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.importKhachDuLich = (listKhachDuLich, tourId) => {
  let api = {
    module: moduleName,
    type: "importTourists",
    value: listKhachDuLich,
    params: {
      tourId: tourId
    },
    message: {
      success: "Thêm mới khách du lịch thành công", //string | null | comment
      error: "Thêm mới khách du lịch không thành công",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.updateFinished = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "Chuyển trạng thái tour thành công", //string | null | comment
      error: "",  //string | null | comment
    },
  };
  return ApiService(api);
};

moduleApi.getTourCountByTourGuideIds = (id) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getTourCountByTourGuideIds",
    value: { hdv_ids: id }
  };
  return ApiService(api);
};

moduleApi.removeKhachDuLich = (tourId, userId) => {
  let api = {
    module: moduleName,
    type: "removeKhachDuLich",
    params: {
      tourId: tourId,
      userId: userId
    },
    message: {
      success: "Xóa khách du lịch thành công", //string | null | comment
      error: "Xóa khách du lịch không thành công",  //string | null | comment
    },
  };
  return ApiService(api);
};

moduleApi.checkActiveSoThe = (soThe) => {
  let api = {
    module: "$auth",
    type: "checkActive",
    value: soThe,
    message: {
      success: "hidden", //string | null | comment
      error: "Tìm kiếm không thành công",  //string | null | comment
    },
  };
  return ApiService(api);
};

moduleApi.addKhachDuLichBySoThe = (tourId, soThe) => {
  let api = {
    module: moduleName,
    type: "addTouristByCardCode",
    params: {
      tourId: tourId,
      cardCode: soThe
    }
    // message: {
    //   success: "Xóa khách du lịch thành công", //string | null | comment
    //   error: "Xóa khách du lịch không thành công",  //string | null | comment
    // },
  };
  return ApiService(api);
};

export default moduleApi;
